<div class="row mb-2 pointer" *ngIf="muro" [ngClass]="{'small': muro.nivel > 0}" (click)="goPerfil(muro.slug)"  [class.blur-strong]="misdatos.perfilPublico == 'no_publico'">
  <div class="col-auto m-0 p-0 me-1">
    <div class="imagenes-montadas imagenes-montadas-mas">
      <img
        *ngIf="muro?.foto_principal_thumb"
        [src]="muro?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
        class="rounded-circle pointer"
        [style.width]="muro.nivel > 0 ? '40px' : '50px'"
        [style.zIndex]="hoverPrincipal ? 999 : muro.mascotas?.length + 1"
        (mouseenter)="hoverPrincipal = true"
        (mouseleave)="hoverPrincipal = false">
      <!--<img *ngFor="let mascota of getMascotasLimitadas(muro.mascotas); let i = index"
        [src]="mascota.foto.foto_thumb"
        class="rounded-circle pointer"
        [style.width]="muro.nivel > 0 ? '30px' : '40px'"
        [style.zIndex]="hoverIndex === i ? 999 : muro.mascotas?.length - i"
        (mouseenter)="hoverIndex = i"
        (mouseleave)="hoverIndex = null">-->
    </div>
  </div>
  <div class="col m-0 p-0">
    <span class="fw-bold">{{muro.first_name}}</span>
    <span class="text-secondary" *ngIf="muro.mascotas?.length > 0">
      con
      <span *ngFor="let mascota of getMascotasLimitadas(muro.mascotas); let i = index">
        <span class="">{{ mascota.ma_nombre | firstWord }}</span>
        <span *ngIf="i < getMascotasLimitadas(muro.mascotas).length - 2">, </span>
        <span *ngIf="i === getMascotasLimitadas(muro.mascotas).length - 2"> y </span>
      </span>
    </span>
    <div class="row">              
      <div class="col-auto small text-secondary">{{muro.rs_fechahora | cuandoFechas}}</div>
      <div class="col-auto small text-secondary" *ngIf="muro.rs_ciudad">
        <i class="fa-solid fa-location-dot"></i> {{muro.rs_ciudad}}<span *ngIf="muro.rs_pais">, {{muro.rs_pais}}</span>
      </div>
    </div>
  </div>
  <div class="col-auto text-end" *ngIf="muro.rs_alcance == '1' && muro.nivel == 0">
    <span class="post-type alcance{{muro.rs_alcance}}">Solo para mí</span>
  </div>
  <div class="col-auto text-end" *ngIf="muro.tipopublicacion && muro.nivel == 0">
    <span class="post-type type{{muro.rs_tipo_publicacion}}">{{muro.tipopublicacion}}</span>
  </div>
</div>
